import "@shopify/polaris/build/esm/styles.css";
import React from 'react';
// import ReactDOM from 'react-dom';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
//import registerServiceWorker from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const root = ReactDOM.createRoot(rootElement);
root.render(<App />);

// ReactDOM.render(
//     // <BrowserRouter basename={baseUrl} >
//         <App />,
//     // </BrowserRouter>,
//     rootElement);

//registerServiceWorker();

